import axios from 'axios';
import { ROOT_API_URL } from '../../../api-config';
import {loader, toastr} from '../CommonActions'
import { auth, userService} from '../../../services';

export const GET_ORGANIZATIONS_SUCCESS = 'GET_ORGANIZATIONS_SUCCESS';
export const ADD_ADMIN_ORGANIZATION = 'ADD_ADMIN_ORGANIZATION';
export const DELETE_ADMIN_ORGANIZATION = 'DELETE_ADMIN_ORGANIZATION';
export const UPDATE_ADMIN_ORGANIZATION = 'UPDATE_ADMIN_ORGANIZATION';

const successColor =  "success";
const errorColor = "danger";
const warningColor = "warning";

export function fetchAllOrganizations() {
    return function (dispatch) {
		dispatch(loader(true));
		var url = `${ROOT_API_URL}/ManageOrganization/GetOrganizations`;
		const options = { method: 'GET', headers: auth.authHeader() };
		axios
			.get(url, options)
			.then((response) => {
				dispatch({
					type: GET_ORGANIZATIONS_SUCCESS,
					payload: response.data
				});
				dispatch(loader(false));
			})
			.catch((error) => {
				var err = "Network Connection Error"; 
				dispatch(loader(false));		
				dispatch(toastr(true,err, errorColor));
			});
	};
}

export function addAdminOrganization(organization) {
	return function(dispatch) {
		dispatch(loader(true));
		var url = `${ROOT_API_URL}/ManageOrganization/CreateAdminOrganization`;
		const options = { method: 'POST', headers: auth.authHeader() };
		axios.post(url, organization, options).then(function(response) {
				if (response && response.data && response.data.issuccess) 
				{
					dispatch({
						type: ADD_ADMIN_ORGANIZATION,
						payload: response.data.organizationList,
					});
					var success = response && response.data ? response.data.message : "Organization Created Successfully"; 
					dispatch(toastr(true,success, successColor));
				}
				else {
					var err = response && response.data ? response.data.message : "Organization Already Exists"; 
					dispatch(toastr(true,err, warningColor));
				}
				dispatch(loader(false));
			})
			.catch((response) => {
				var err = response && response.data ? response.data.message : "Network Connection Error"; 
				dispatch(loader(false));		
				dispatch(toastr(true,err, errorColor));
			});
	};
}

export function deleteOrganization(organization) {
	return function(dispatch) {
		dispatch(loader(true));
		var url = `${ROOT_API_URL}/ManageOrganization/DeleteOrganization`;
		const options = { method: 'POST', headers: auth.authHeader() };
		axios.post(url, organization, options).then(function(response) {
			if (response && response.data && response.data.issuccess) 
				{
					dispatch({
						type: DELETE_ADMIN_ORGANIZATION,
					payload: response.data.organizationList
					});	
					var success = response && response.data ? response.data.message : "Organization De-activated Successfully"; 
					dispatch(toastr(true,success, successColor));
				}
				else {
					var err = response && response.data ? response.data.message : "Error Occured"; 
					dispatch(toastr(true,err, warningColor));
				}
				dispatch(loader(false));
			})
			.catch((response) => {
				dispatch(loader(false));

				var err = response && response.data ? response.data.message : "Network Connection Error"; 
				dispatch(toastr(true,err, errorColor));
			});
	};
}

export function updateAdminOrganization(organization) {
	return function(dispatch) {
		dispatch(loader(true));
		var url = `${ROOT_API_URL}/ManageOrganization/UpdateAdminOrganization`;
		const options = { method: 'POST', headers: auth.authHeader() };
		axios.post(url, organization, options).then(function(response) {
				console.log("update response", response)
				if (response && response.data && response.data.issuccess) 
				{
					dispatch({
						type: UPDATE_ADMIN_ORGANIZATION,
						payload: response.data.organizationList
					});	
					var success = response && response.data ? response.data.message : "Organization Updated Successfully"; 
					dispatch(toastr(true,success, successColor));
				}
				else {
					var err = response && response.data ? response.data.message : "Error Occured"; 
					dispatch(toastr(true,err, warningColor));
				}
				dispatch(loader(false));
			})
			.catch((response) => {
				var err = response && response.data ? response.data.message : 'Network Connection Error';
				dispatch(loader(false));
				dispatch(toastr(true, err, errorColor));
			});
	};
}

export function SaveAdminOrganization(organization) {
	return function (dispatch) {
		dispatch(loader(true));
		var url = `${ROOT_API_URL}/ManageOrganization/SaveAdminOrganization`;
		const options = { method: 'POST', headers: auth.authHeader() };
		axios.post(url, organization, options).then(function (response) {
		})
			.catch((response) => {
				var err = response && response.data ? response.data.message : 'Network Connection Error';
				dispatch(loader(false));
				dispatch(toastr(true, err, errorColor));
			});
	};
}